import model from '../../models-v2/crm/mail-groups';
import routeName from '../route-name';

export default [
  {
    path: '/mailing/groups',
    name: routeName.mailGroups.index,
    components: {
      default: () => import('../../pages/data-grid.vue'),
      topRightSection: () => import('../../views/pages/mailing/components/MailingTemplateTopRightSection.vue'),
      popup: () => import('../../views/pages/mailing/components/Popup.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Mailing', url: '/mailing' },
        { title: 'Grupy odbiorców', url: '/mailing/groups' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    path: '/mailing/groups/add',
    name: routeName.mailGroups.store,
    component: () => import('../../views/pages/mailing/components/MailingGroupForm.vue'),
    meta: {
      breadcrumb: [
        { title: 'Grupy odbiorców', url: '/mailing/groups' },
        { title: 'Lista', url: '/mailing/groups' },
      ],
    },
  },
  {
    path: '/mailing/groups/edit/:id',
    name: routeName.mailGroups.edit,
    component: () => import('../../views/pages/mailing/components/MailingGroupForm.vue'),
    meta: {
      breadcrumb: [
        { title: 'Grupy odbiorców', url: '/mailing/groups' },
        { title: 'Lista', url: '/mailing/groups' },
      ],
    },
  },
];